import PropTypes from 'prop-types'

import {Avatar, AVATAR_SIZES} from '@adv-mt/ui/avatar'
import {LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'

export const BASE_CLASS = 'mt-SellerInfo'

const SellerAvatar = ({sellerName, sellerLogo, sellerPhoto, isProfessional}) => {
  if (isProfessional) {
    if (!sellerLogo) return null

    return (
      <MediaImage
        alt={sellerName}
        className={`${BASE_CLASS}-logo`}
        loading={LOADING.LAZY}
        objectFit={OBJECT_FIT.CONTAIN}
        src={sellerLogo}
      />
    )
  }

  return <Avatar alt={sellerName} name={sellerName} size={AVATAR_SIZES.LARGE} src={sellerPhoto} />
}

SellerAvatar.displayName = 'SellerAvatar'

SellerAvatar.propTypes = {
  sellerName: PropTypes.string,
  sellerLogo: PropTypes.string,
  sellerPhoto: PropTypes.string,
  isProfessional: PropTypes.bool
}

export default SellerAvatar
